var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',{staticClass:"zh-content"},[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-layout',[_c('CustomLogin')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }